// extracted by mini-css-extract-plugin
module.exports = {"layout":"angled-section_layout__JMyBc","topOnly":"angled-section_topOnly__IOajD","wrapper":"angled-section_wrapper__afgrI"};